import React, { useState } from 'react';
import { Form, Input, Button, Space, Table, Popconfirm, message, Select, Modal } from 'antd';
import { DeleteOutlined, SearchOutlined, EditOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

import CityEditForm from './CityEditForm';
import InputRules from '../../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../../store/actions';
import { useEffect } from 'react';

const layout = {
	labelCol: {
		span: 3,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 3,
		span: 16,
	},
};

const CityManagement = ({ cities, fetchCities, addCity, updateCity, deleteCity }) => {
	const [editCity, setEditCity] = useState();
	const [editModal, setEditModal] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [searchedColumn, setSearchedColumn] = useState('');

	useEffect(() => {
		fetchCities();
	}, []);

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: function filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
			return (
				<div style={{ padding: 8 }}>
					<Input
						placeholder={`Search ${dataIndex}`}
						value={selectedKeys[0]}
						onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
						onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
						style={{ width: 188, marginBottom: 8, display: 'block' }}
					/>
					<Space>
						<Button
							type="primary"
							onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
							icon={<SearchOutlined />}
							size="small"
							style={{ width: 90 }}
						>
							Search
						</Button>
						<Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
							Reset
						</Button>
					</Space>
				</div>
			);
		},
		filterIcon: function filter(filtered) {
			return <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;
		},
		onFilter: (value, record) =>
			record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
		render: function render(text) {
			return searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text ? text.toString() : ''}
				/>
			) : (
				text
			);
		},
	});

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText('');
	};

	const onFinish = async (values) => {
		await addCity(values);
		fetchCities();
	};

	const onDelete = async (id) => {
		await deleteCity(id);
		fetchCities();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const columns = [
		{
			title: 'City',
			dataIndex: '_id',
			key: '_id',
			sorter: (a, b) => {
				if (a._id.toLowerCase() < b._id.toLowerCase()) return -1;
				if (a._id.toLowerCase() > b._id.toLowerCase()) return 1;
				return 0;
			},
			...getColumnSearchProps('_id'),
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: (a, b) => {
				if (a._id.toLowerCase() < b._id.toLowerCase()) return -1;
				if (a._id.toLowerCase() > b._id.toLowerCase()) return 1;
				return 0;
			},
			...getColumnSearchProps('country'),
		},
		{
			title: 'Action',
			key: 'action',
			render: function action(text, record) {
				return (
					<>
						<EditOutlined
							onClick={() => {
								setEditCity(record);
								setEditModal(!editModal);
							}}
						/>
						<Popconfirm
							title="Are you sure to delete this city?"
							onConfirm={() => onDelete(record._id)}
							okText="Yes"
							cancelText="No"
						>
							<DeleteOutlined />
						</Popconfirm>
					</>
				);
			},
		},
	];

	return (
		<div className="city-page">
			<Form {...layout} name="city-form" onFinish={onFinish} onFinishFailed={onFinishFailed}>
				<Form.Item label="City" name="city" rules={InputRules.required('Please input city!')}>
					<Input />
				</Form.Item>
				<Form.Item label="Country" name="country" rules={InputRules.required('Please select country!')}>
					<Select>
						<Select.Option value="PK">Pakistan</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					label="Priority"
					name="priority"
					rules={InputRules.number({ required: true, message: 'Please input priority', min: 0 })}
				>
					<Input />
				</Form.Item>
				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit">
						Add City
					</Button>
				</Form.Item>
			</Form>
			<Table dataSource={cities} columns={columns} rowKey={(record) => record._id} size="small" scroll={{ x: true }} />
			<Modal
				title={`Edit ${editCity?._id}`}
				centered={true}
				visible={editModal}
				footer={null}
				onCancel={() => setEditModal(false)}
				destroyOnClose={true}
			>
				<CityEditForm
					city={editCity}
					updateCity={updateCity}
					updateList={fetchCities}
					setEditModal={() => setEditModal(false)}
				/>
			</Modal>
		</div>
	);
};

const mapStateToProps = (store) => ({
	cities: store.city.cities,
});

const mapDispatchToProps = (dispatch) => ({
	fetchCities: () => dispatch(Actions.fetchCities()),
	addCity: (body) => dispatch(Actions.addCity(body)),
	updateCity: (id, body) => dispatch(Actions.updateCity(id, body)),
	deleteCity: (id) => dispatch(Actions.deleteCity(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CityManagement);
